import { render } from "./beamer-changelog-banner.vue?vue&type=template&id=5f48be87"
import script from "./beamer-changelog-banner.vue?vue&type=script&lang=js"
export * from "./beamer-changelog-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__